import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section className="client_had p-100 text_second_text">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Introduction</h2>
            <p>
              TruthGPT was conceived as a response to the challenges posed by
              misinformation in the digital age.
            </p>
            <p>
              It aimed to surpass conventional chatbots by incorporating
              advanced technologies like blockchain and 3D modeling.
            </p>
            <p>
              The app promises users an experience where information is not only
              readily available but also trustworthy, making it a valuable
              resource in a world inundated with digital content.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Introduction.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={608}
                height={594}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
